export default {
  data() {
    return {
      onUpdateCallback: {},
      onSaveCallback: {},
      onCancelCallback: {},
      onNextCallback: {},
      onPrevCallback: {},
      _keyHandler: null,
    };
  },

  methods: {
    setKeyHandlerCallback(type, callback) {
      if (typeof callback !== 'function') {
        this._detachKeyHandler();
        return;
      }

      this._attachKeyHandler();

      const registry = {
        update: ['onUpdateCallback', 'isUpdate'],
        save: ['onSaveCallback', 'isSave'],
        cancel: ['onCancelCallback', 'isCancel'],
        next: ['onNextCallback', 'isNext'],
        prev: ['onPrevCallback', 'isPrev'],
      };

      const [holder, flag] = registry[type] || [];
      if (holder) this[holder] = { callback, [flag]: true };
    },

    handleKeyDown(event) {
      if (event.shiftKey && event.key === 'Enter') return;
      if (!['Enter', 'Escape', 'Tab', 'Shift'].includes(event.key)) return;
      const customKey =
        event.shiftKey && event.key === 'Tab' ? 'Shift_Tab' : event.key;
      const actions = [
        { key: 'Enter', flag: 'isUpdate', holder: this.onUpdateCallback },
        { key: 'Enter', flag: 'isSave', holder: this.onSaveCallback },
        { key: 'Escape', flag: 'isCancel', holder: this.onCancelCallback },
        { key: 'Tab', flag: 'isNext', holder: this.onNextCallback },
        {
          key: 'Shift_Tab',
          flag: 'isPrev',
          holder: this.onPrevCallback,
        },
      ];
      // Find the action that matches the key pressed
      const matched = actions.find(
        ({ key, flag, holder }) =>
          customKey === key &&
          holder?.[flag] &&
          typeof holder.callback === 'function'
      );

      if (matched) {
        event.preventDefault();
        matched.holder.callback();
        matched.holder.callback = null;
        this._detachKeyHandler();
      }
    },

    _attachKeyHandler() {
      if (!this._keyHandler) {
        this._keyHandler = (event) => this.handleKeyDown(event);
        window.addEventListener('keydown', this._keyHandler);
      }
    },

    _detachKeyHandler() {
      if (this._keyHandler) {
        window.removeEventListener('keydown', this._keyHandler);
        this._keyHandler = null;
      }
    },
  },

  beforeDestroy() {
    this._detachKeyHandler();
  },
};
